import { legacyIssueCreateCombinedInteraction } from './legacyIssueCreateCombinedInteraction.tsx';
import { legacyIssueCreateInitialRenderInteraction } from './legacyIssueCreateInitialRenderInteraction.tsx';
import { legacyIssueCreateTransitionInteraction } from './legacyIssueCreateTransitionInteraction.tsx';
import type { TriggerSource } from './TriggerSource.types.tsx';

export const sendStartMarkForLegacyIssueCreate = ({
	isInitialLoad,
	triggerSource,
}: {
	isInitialLoad?: boolean;
	triggerSource?: TriggerSource;
}): void => {
	if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
		if (isInitialLoad) {
			legacyIssueCreateInitialRenderInteraction.start();
		} else {
			legacyIssueCreateTransitionInteraction.start();
		}
		legacyIssueCreateCombinedInteraction.start();
	}
};
